import {Component, OnDestroy, OnInit} from '@angular/core';
import {NgbAlert} from '@ng-bootstrap/ng-bootstrap';
import {NgForOf} from '@angular/common';
import {AlertService} from './alert.service';
import {Subscription} from 'rxjs';
import {Alert} from "./alert";

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    imports: [NgbAlert, NgForOf],
})
export class AlertComponent implements OnInit, OnDestroy {
    private alertsSubscription!: Subscription;

    alerts: Alert[] = [];

    constructor(private alertService: AlertService) {
    }

    ngOnInit() {
        this.alertsSubscription = this.alertService.alerts$.subscribe(
            (alerts) => {
                this.alerts = alerts;
            }
        );
    }

    closeAlert(index: number) {
        this.alertService.closeAlert(index);
    }

    ngOnDestroy() {
        if (this.alertsSubscription) {
            this.alertsSubscription.unsubscribe();
        }
    }
}
